import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
import { ProgressBar } from '../components/ProgressBar';
import { quizData } from '../data/quizData';
import { Check } from 'lucide-react';
export const Quiz = () => {
  const {
    setCurrentPage,
    answers,
    setAnswer
  } = useAppContext();
  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [multiSelections, setMultiSelections] = useState<string[]>([]);
  const [showReinforcement, setShowReinforcement] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState<number | null>(null);
  const question = quizData[currentQIndex];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentQIndex]);
  const handleSingleSelect = (optionTag: string, optionIndex: number) => {
    setAnswer(currentQIndex, optionTag);
    setSelectedOptionIndex(optionIndex);
    if (question.reinforcement) {
      setShowReinforcement(true);
      setTimeout(() => {
        advance();
      }, 2500);
    } else {
      setTimeout(() => {
        advance();
      }, 400);
    }
  };
  const handleMultiToggle = (optionTag: string) => {
    if (optionTag === 'TOOL_NONE') {
      setMultiSelections(['TOOL_NONE']);
      return;
    }
    setMultiSelections(prev => {
      const filtered = prev.filter(t => t !== 'TOOL_NONE');
      if (filtered.includes(optionTag)) {
        return filtered.filter(t => t !== optionTag);
      }
      return [...filtered, optionTag];
    });
  };
  const handleMultiSubmit = () => {
    if (multiSelections.length === 0) return;
    setAnswer(currentQIndex, multiSelections);
    if (question.reinforcement) {
      setShowReinforcement(true);
      setTimeout(() => {
        advance();
      }, 2500);
    } else {
      advance();
    }
  };
  const advance = () => {
    setShowReinforcement(false);
    setSelectedOptionIndex(null);
    setMultiSelections([]);
    if (currentQIndex < quizData.length - 1) {
      setCurrentQIndex(prev => prev + 1);
    } else {
      setCurrentPage('email');
    }
  };
  const getReinforcementMessage = () => {
    if (!question.reinforcement || selectedOptionIndex === null) return null;
    const isHigh = question.reinforcement.highOptions.includes(selectedOptionIndex);
    return isHigh ? question.reinforcement.high : question.reinforcement.low;
  };
  return <div className="min-h-screen bg-bg" data-id="element-281">
      <div className="bg-surface py-3 px-5 border-b border-border" data-id="element-282">
        <ProgressBar current={currentQIndex + 1} total={quizData.length} label={`Pregunta ${currentQIndex + 1} de ${quizData.length}`} data-id="element-283" />
      </div>

      <div className="max-w-[720px] mx-auto px-5 py-8 pb-20" data-id="element-284">
        <AnimatePresence mode="wait" data-id="element-285">
          <motion.div key={currentQIndex} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.3
        }} data-id="element-286">
            <div className="text-center text-[13px] text-textlight italic mb-2" data-id="element-287">
              {question.context}
            </div>

            <h2 className="text-[20px] sm:text-[24px] font-bold text-dark text-center leading-[1.35] mb-7 whitespace-pre-line" data-id="element-288">
              {question.question}
            </h2>

            <div className="space-y-2.5" data-id="element-289">
              {question.options.map((option, idx) => {
              const isSelected = question.type === 'single' ? selectedOptionIndex === idx : multiSelections.includes(option.tag);
              return <div key={idx} onClick={() => question.type === 'single' ? handleSingleSelect(option.tag, idx) : handleMultiToggle(option.tag)} className={`bg-white border-2 rounded-xl py-3.5 px-4 cursor-pointer transition-all duration-200 flex items-center gap-3 text-[15px] text-text
                      ${isSelected ? 'bg-primary border-primary text-white shadow-primary-sm' : 'border-border hover:border-primary hover:bg-primary/5'}`} data-id="element-290">
                    <span className="text-[20px] shrink-0" data-id="element-291">{option.emoji}</span>
                    <span data-id="element-292">{option.text}</span>

                    {question.type === 'multi' && <div className={`ml-auto w-5 h-5 border-2 rounded flex items-center justify-center shrink-0
                        ${isSelected ? 'bg-white border-white text-primary' : 'border-border'}`} data-id="element-293">
                        {isSelected && <Check size={14} strokeWidth={3} data-id="element-294" />}
                      </div>}
                  </div>;
            })}
            </div>

            {question.type === 'multi' && !showReinforcement && <button onClick={handleMultiSubmit} disabled={multiSelections.length === 0} className="mt-6 bg-primary hover:bg-[#e55a00] disabled:bg-gray-300 disabled:cursor-not-allowed text-white border-none rounded-xl py-4 px-8 text-[17px] font-bold cursor-pointer w-full block transition-all duration-200" data-id="element-295">
                Continuar →
              </button>}

            {showReinforcement && <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="bg-[#E8F5E9] border-l-4 border-success rounded-lg py-3 px-4 text-[14px] text-[#1B5E20] mt-4 flex gap-2 items-start" data-id="element-296">
                <span className="mt-0.5" data-id="element-297">💡</span>
                <p data-id="element-298">{getReinforcementMessage()}</p>
              </motion.div>}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
};